function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Arrow/Left");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icon/Arrow/Left",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.33189655,17.3594976 C5.09482759,17.1240188 5,16.8414443 5,16.5117739 C5,16.1821036 5.14224138,15.899529 5.33189655,15.6640502 L11.6853448,9.35321821 C12.1594828,8.8822606 12.9181034,8.8822606 13.3448276,9.35321821 C13.8189655,9.82417582 13.8189655,10.577708 13.3448276,11.0015699 L8.98275862,15.3343799 L25.8146552,15.3343799 C26.4784483,15.3343799 27,15.8524333 27,16.5117739 C27,17.1711146 26.4784483,17.689168 25.8146552,17.689168 L9.03017241,17.689168 L13.3922414,22.021978 C13.8663793,22.4929356 13.8663793,23.2464678 13.3922414,23.6703297 C13.1551724,23.9058085 12.8706897,24 12.5387931,24 C12.2068966,24 11.9224138,23.9058085 11.6853448,23.6703297 L5.33189655,17.3594976 Z"
}));

var SvgLeftArrow = function SvgLeftArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeftArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LeftArrow.646ff744.svg";
export { ForwardRef as ReactComponent };